import React, {useState} from 'react'
import {Nav, Button} from 'react-bootstrap'
import ExcludeCustomersView from './ExcludeCustomersView'
import {MfaSettingsPanel} from './mfa/MfaSettingsPanel'

interface InterpreterSettingsViewProps {
  userId: string
}

interface SettingOption {
  id: string
  name: string
  icon: string
  description: string
}

const settingsOptions: SettingOption[] = [
  {
    id: 'exclude-customers',
    name: 'Exclude Customers',
    icon: 'bi bi-person-x',
    description: 'Manage customer exclusion list for this interpreter',
  },
  {
    id: 'mfa',
    name: 'Multi Factor Authentication',
    icon: 'bi bi-shield-lock',
    description: 'Manage MFA methods for this interpreter',
  },
]

export const InterpreterSettingsView: React.FC<InterpreterSettingsViewProps> = ({userId}) => {
  const [selectedOption, setSelectedOption] = useState<string>(settingsOptions[0]?.id || '')

  const renderContent = () => {
    switch (selectedOption) {
      case 'exclude-customers':
        return <ExcludeCustomersView userId={userId} />
      case 'mfa':
        return <MfaSettingsPanel userId={userId} mode='admin' />
      default:
        return (
          <div className='d-flex flex-column align-items-center justify-content-center py-10'>
            <i className='bi bi-gear fs-1 text-gray-400 mb-3'></i>
            <span className='text-gray-500'>Select a setting option from the sidebar</span>
          </div>
        )
    }
  }

  return (
    <div className='row g-5'>
      {/* Sidebar */}
      <div className='col-lg-3 col-md-4'>
        <div className='card card-flush' style={{minHeight: '300px'}}>
          <div className='card-header pt-5 pb-3'>
            <h5 className='card-title fw-bold text-gray-800'>Settings</h5>
          </div>
          <div className='card-body pt-0'>
            <Nav className='flex-column'>
              {settingsOptions.map((option) => (
                <Nav.Item key={option.id} className='mb-2'>
                  <Button
                    variant={option.id === selectedOption ? 'primary' : 'light'}
                    className={`w-100 text-start d-flex align-items-center ${
                      option.id === selectedOption ? '' : 'text-gray-700'
                    }`}
                    onClick={() => setSelectedOption(option.id)}
                    style={{
                      borderRadius: '8px',
                      padding: '12px 16px',
                    }}
                  >
                    <i className={`${option.icon} me-3 fs-4`}></i>
                    <div className='d-flex flex-column align-items-start'>
                      <span className='fw-semibold'>{option.name}</span>
                    </div>
                  </Button>
                </Nav.Item>
              ))}
            </Nav>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className='col-lg-9 col-md-8'>
        <div className='card card-flush'>
          <div className='card-body'>{renderContent()}</div>
        </div>
      </div>
    </div>
  )
}

export default InterpreterSettingsView
